import { v4 as uuidv4 } from "uuid";

export function generateRandomRecordId(): string {
  return Math.floor(10000000 + Math.random() * 90000000).toString();
}

/**
 * IRS UniqueTransmissionId: "<uuid>:IRIS:<TCC>::A".
 *
 * EXTRACTION NOTE: the TCC used to be read from the A2A_TCC_CODE environment variable.
 * It is now a required parameter, supplied by callers from ctx.irs.tcc.
 */
export function generateUniqueTransmissionId(tcc: string): string {
  const uuid = uuidv4();
  return `${uuid}:IRIS:${tcc}::A`;
}

/**
 * Generates a unique submission ID (numeric, max 8 digits).
 */
export function generateUniqueSubmissionId(): string {
  // Generate a random 7-digit number (since first digit must be 1-9)
  const random7Digits = Math.floor(1000000 + Math.random() * 9000000);
  // Generate first digit (1-9)
  const firstDigit = Math.floor(1 + Math.random() * 9);
  // Combine to make 8 digits
  return `${firstDigit}${random7Digits}`;
}
